import { render, staticRenderFns } from "./XuCountryCode.vue?vue&type=template&id=49372f66&scoped=true"
import script from "./XuCountryCode.vue?vue&type=script&lang=js"
export * from "./XuCountryCode.vue?vue&type=script&lang=js"
import style0 from "./XuCountryCode.vue?vue&type=style&index=0&id=49372f66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49372f66",
  null
  
)

export default component.exports